import { NOT_FOUND } from 'redux-first-router';

const pages = [
  'Home',
  'Snapshot',
  'Ranking',
  'MyProfile',
  'MyRankings',
  'RankingInvite',
  'RankingDetails',
  'Snapshots',
  'Scores',
  'Login',
  'Signup',
  'Matches',
  'Fixture',
  'FixtureEmbed',
  'Rules',
  'TermsAndConditions',
];

const action = (key) => `PAGE_${key.toUpperCase()}`;

export const actions = pages.reduce(
  (all, k) => ({ ...all, [k]: action(k) }),
  {}
);

export const namesOfAction = pages.reduce(
  (all, k) => ({ ...all, [action(k)]: k }),
  {}
);

export const components = {
  ...pages.reduce((all, k) => ({ ...all, [action(k)]: k }), {}),
  [action('NOT_FOUND')]: NOT_FOUND,
};

export const subnames = {
  SUBPAGE_RESULTS: 'results',
  SUBPAGE_FORECAST: 'forecast',
};

export default pages.reduce((all, k) => ({ ...all, [k]: k }), {});
